import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import Header from './layout-components/header/header';
import Sidebar from './layout-components/sidebar/sidebar';
import Footer from './layout-components/footer/footer';
import {getSidebarMenus} from '../routes/router';
import {BreadcrumbItem} from "reactstrap";
import {history} from "../jwt/_helpers";
import componentsSidebar from "../routes/data";

const mapStateToProps = state => ({
	...state
});

function udnIcon(){
	try {
		const udn = JSON.parse( localStorage.getItem('selectedUdn') );
		let img;
		img = require("../assets/images/icon/parks/svg/" + udn.iconXkynet + ".svg");
		return <div className={`udn udn-${udn.code.toString().toLowerCase()} udn-gradient-${udn.code.toString().toLowerCase()}`}>
			<img src={img} />
			<label>{udn.label}</label>
		</div>
	} catch (e) {
		return null;
	}
}

class FullLayout extends React.Component {
	constructor(props) {
		super(props);
		this.updateDimensions = this.updateDimensions.bind(this);
		this.state = {
			isOpen: false,
			width: window.innerWidth,
			udns: JSON.parse(localStorage.getItem('udns')),
			itemsMenu: getSidebarMenus(),
			pathBreadcrumb: false
		};
		this.showBreadcrumb = this.showBreadcrumb.bind(this);
		this.buildBreadcrumbs = this.buildBreadcrumbs.bind(this);

		this.props.history.listen((location, action) => {
			if (window.innerWidth < 767 &&
				document.getElementById('main-wrapper').className.indexOf("show-sidebar") !== -1) {
				document.getElementById('main-wrapper').classList.toggle("show-sidebar");
			}
		});
	}

	showBreadcrumb(onOff){
		this.setState({pathBreadcrumb: onOff});
	}

	/*--------------------------------------------------------------------------------*/
	/*Life Cycle Hook, Applies when loading or resizing App                           */
	/*--------------------------------------------------------------------------------*/
	componentDidMount() {
		window.addEventListener("load", this.updateDimensions);
		window.addEventListener("resize", this.updateDimensions);
		this.setState({itemsMenu: getSidebarMenus()});
	}
	/*--------------------------------------------------------------------------------*/
	/*Function that handles sidebar, changes when resizing App                        */
	/*--------------------------------------------------------------------------------*/
	updateDimensions() {
		let element = document.getElementById('main-wrapper');
		this.setState({
			width: window.innerWidth
		});
		switch (this.props.settings.activeSidebarType) {
			case 'full':
			case 'iconbar':
				if (this.state.width < 1170) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
					element.classList.add("mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.props.settings.activeSidebarType);
					element.classList.remove("mini-sidebar");
				}
				break;

			case 'overlay':
				if (this.state.width < 767) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.props.settings.activeSidebarType);
				}
				break;

			default:
		}
	}

	/*--------------------------------------------------------------------------------*/
    /*Life Cycle Hook                                                                 */
	/*--------------------------------------------------------------------------------*/
	componentWillUnmount() {
		window.removeEventListener("load", this.updateDimensions);
		window.removeEventListener("resize", this.updateDimensions);
	}

	buildBreadcrumbs() {
		let basePath = history.location.pathname.replace('/main', '');
		let path = (basePath in componentsSidebar) ? componentsSidebar[basePath].breadcrumb : basePath;
		let breads = path.split("/");
		let breadcrumb = [];
		breads.map((value, key) => {
			if (value === "") {
				return
			}
			breadcrumb.push(<BreadcrumbItem>
				<i className={"default-text"} ref={value}>{value}</i>
			</BreadcrumbItem>);
		});

		return breadcrumb;
	}

	buildOptionsToSelect(udns) {
		let options = [];
		if (udns) {
			let selected = localStorage.getItem('selected');
			Object.values(udns).map((udn, key) => {
				options.push(<option selected={udn.name === selected} value={udn.id}>{udn.name}</option>);
			});
		}
		return options;
	}

	render() {
		/*--------------------------------------------------------------------------------*/
		/* Theme Setting && Layout Options wiil be Change From Here                       */
		/*--------------------------------------------------------------------------------*/
		return (
			<div
				id="main-wrapper"
				dir={this.props.settings.activeDir}
				data-theme={this.props.settings.activeTheme}
				data-layout={this.props.settings.activeThemeLayout}
				data-sidebartype={this.props.settings.activeSidebarType}
				data-sidebar-position={this.props.settings.activeSidebarPos}
				data-header-position={this.props.settings.activeHeaderPos}
				data-boxed-layout={this.props.settings.activeLayout}
			>
				{/*--------------------------------------------------------------------------------*/}
				{/* Header                                                                         */}
				{/*--------------------------------------------------------------------------------*/}
				<Header />
				{/*--------------------------------------------------------------------------------*/}
				{/* Sidebar                                                                        */}
				{/*--------------------------------------------------------------------------------*/}
				<Sidebar {...this.props} routes={this.state.itemsMenu} />
				{/*--------------------------------------------------------------------------------*/}
				{/* Page Main-Content                                                              */}
				{/*--------------------------------------------------------------------------------*/}
				<div className="page-wrapper d-block" >
					<div className="page-content container-fluid">
						{/*<Breadcrumb>*/}
						{/*	<BreadcrumbItem>*/}
						{/*		{this.state.udns != '' && this.state.pathBreadcrumb && <select>*/}
						{/*			{*/}
						{/*				this.buildOptionsToSelect(this.state.udns)*/}
						{/*			}*/}
						{/*		</select>}*/}
						{/*	</BreadcrumbItem>*/}
						{/*	{this.buildBreadcrumbs()}*/}
						{/*</Breadcrumb>*/}
						{/*udnIcon()*/}
						<Switch>
							{this.state.itemsMenu.map((prop, key) => {
								if (prop.navlabel) {
									return null;
								}
								else if (prop.collapse) {
									return prop.child.map((prop2, key2) => {
										if (prop2.collapse) {
											return prop2.subchild.map((prop3, key3) => {
												return (
													<Route path={prop3.path}
														   render={() => <prop3.component showHideBreadcrumb={this.showBreadcrumb}/>} key={key3}
													/>
												);
											});
										}
										this.buildBreadcrumbs(prop2.breadcrumbPath);
										return (
											<Route path={prop2.path} key={key2}
												   render={() => <prop2.component showHideBreadcrumb={this.showBreadcrumb}/>}
											/>
										);
									});
								}
								else if (prop.redirect) {
									return (
										<Redirect from={prop.path} to={prop.pathTo} key={key}
										/>
									);
								}
								else {
									const menu = {
										code: prop.code,
										name: prop.name,
										categoryCode: prop.categoryCode,
										url: prop.url
									}
									return (
										<Route
											key={key}
											path={prop.path}
											showHideBreadcrumb={this.showBreadcrumb}
											render={() => <prop.component app={prop.app} categoryCode={prop.categoryCode} menu={menu}/>}
										/>
									);
								}
							})}
						</Switch>
					</div>
					<Footer />
				</div>
			</div>
		);
	}
}
export default connect(mapStateToProps)(FullLayout);
